import { Link } from 'react-router-dom';
import { SeoHead, organizationLd, webSiteLd, webPageLd } from '../seo';

export default function PinYourRent() {
  return (
    <>
      <SeoHead
        title="Pin What You Pay for Parking — Help India | Parksy"
        description="Don't have parking to rent? Pin what you currently pay and help others in your locality negotiate fair rates. 100% anonymous, free."
        canonical="https://parksy.rent/pin-your-rent"
        ogImage="https://parksy.rent/og/pin-your-rent.png"
        schemas={[organizationLd(), webSiteLd(), webPageLd({ name: 'Pin What You Pay', description: 'Help others in your area by pinning what you pay for parking.', url: 'https://parksy.rent/pin-your-rent' })]}
      />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Pin what you pay. Help your neighbourhood.</h1>
        <p className="text-lg text-gray-600 mb-8">
          You don't have to rent out a spot to contribute. Drop a quick "rent pin" with the
          rate you currently pay, and the next person moving into your area can negotiate
          from real data instead of guesswork.
        </p>

        <Link
          to="/"
          className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-medium px-6 py-3 rounded-lg"
        >
          Open the map and drop a rent pin →
        </Link>

        <div className="mt-12 bg-white border rounded-xl p-6">
          <h2 className="font-semibold text-gray-900 mb-3">Why your pin matters</h2>
          <ul className="space-y-2 text-gray-600 text-sm">
            <li>• Crowdsourced price data is the only honest price benchmark in India.</li>
            <li>• No personal data is exposed. Only the rate + parking type is public.</li>
            <li>• Helps travelers, students, and newcomers avoid overpaying.</li>
          </ul>
        </div>
      </div>
    </>
  );
}
